import { Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
// import store, {changeName, increase} from './store.js'
import { addCount, decreaseCount, deleteItem, sortName } from './store'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom';



interface RootState {
    user: {
        name: string;
        age: number;
    };
    cart: {
        id: number;
        imgurl: string;
        name: string;
        count: number;
    }[];
}

function Cart(): JSX.Element {
    const state = useSelector((state: RootState) => state);
    const dispatch = useDispatch();



    const smallProductStyle: React.CSSProperties = {
        border: '1px solid #ddd',
        width: '100px',
        height: '80px',
        cursor: 'pointer',
    };

    const textVerticalAlign: React.CSSProperties = {
        verticalAlign: 'middle',
        textAlign: 'center',
    };

    return (
        <>
            <h5 style={{ padding: "50px" }}>
                {state.user.name} {state.user.age}의 장바구니
            </h5>
            {/* <button onClick={()=>{ dispatch(increase())}}>나이+</button>
       <button onClick={()=>{ dispatch(increase(100))}}>나이+</button> */}
            <Table style={{ width: "1350px", margin: "0 auto" }}>
                <thead>
                    <tr>
                        <th>id</th>
                        <th>상품이미지</th>
                        <th>상품명</th>
                        <th>수량</th>
                        <th>변경하기</th>
                    </tr>
                </thead>
                <tbody>
                    {state.cart.map((a, i) => (
                        <tr key={i}>
                            <td style={textVerticalAlign}>{state.cart[i].id + 1}</td>

                            <td>
                                <Link to={`/detail/${state.cart[i].id}`}>
                                    <img
                                        src={`img/${state.cart[i].imgurl}`}
                                        style={smallProductStyle}
                                    />
                                </Link>
                            </td>
                            <td style={textVerticalAlign}>{state.cart[i].name}</td>
                            <td style={textVerticalAlign}>{state.cart[i].count}</td>
                            <td style={textVerticalAlign}>
                                <Button
                                    onClick={() => {
                                        dispatch(addCount(state.cart[i].id));
                                    }}
                                    variant="outline-success"
                                    style={{ marginRight: "10px" }}
                                >
                                    +
                                </Button>

                                <Button
                                    onClick={() => {
                                        dispatch(decreaseCount(state.cart[i].id));
                                    }}
                                    variant="outline-warning"
                                    style={{ marginRight: "10px" }}
                                >
                                    -
                                </Button>

                                <Button
                                    onClick={() => {
                                        dispatch(deleteItem(state.cart[i].id));
                                    }}
                                    variant="outline-danger"
                                >
                                    상품삭제
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Button
                variant="outline-primary"
                style={{ marginTop: "20px" }}
                onClick={() => {
                    dispatch(sortName());
                }}
            >
                이름순정렬
            </Button>{" "}
            <div className="cart_img" style={{ marginTop: "60px" }}>
                <img src="/types/img/cart/img.png" />
            </div>
        </>
    );
}

export default Cart;
